import { Text, StackChildren, Colors } from '@doordash/design-language'
import * as React from 'react'
import * as DA from '../../../typeModules/events'

import t from './strings'

export type ActivatedNoFirstDashSlide = {
  key: DA.ActivatedNoFirstDashScreens
  title: string
  subtitle: string
  content: JSX.Element
}

const StartADashContent = (
  <StackChildren size={StackChildren.Sizes.XxSmall}>
    <Text color={Colors.SystemGrey80}>{t.start.content1()}</Text>
    <div>
      <Text color={Colors.SystemGrey80}>{t.start.content2()}</Text>
      <Text color={Colors.SystemGrey80}>{t.start.content3()}</Text>
    </div>
  </StackChildren>
)

const AcceptAnOrderContent = (
  <StackChildren size={StackChildren.Sizes.XxSmall}>
    <Text color={Colors.SystemGrey80}>{t.heatmap.content1()}</Text>
    <Text color={Colors.SystemGrey80}>{t.heatmap.content2()}</Text>
  </StackChildren>
)

const CompleteAnOrderContent = (
  <StackChildren size={StackChildren.Sizes.XxSmall}>
    <Text styles={Text.Styles.Bold16} color={Colors.SystemGrey80}>
      {t.order.content1()}
    </Text>
    <Text color={Colors.SystemGrey80}>{t.order.content2()}</Text>
    <Text color={Colors.SystemGrey80}>{t.order.content3()}</Text>
  </StackChildren>
)

const GetSupportContent = (
  <StackChildren size={StackChildren.Sizes.XxSmall}>
    <Text color={Colors.SystemGrey80}>{t.support.content1()}</Text>
    <Text color={Colors.SystemGrey80}>{t.support.content2()}</Text>
  </StackChildren>
)

export const activatedNoFirstDashSlideDeck: ActivatedNoFirstDashSlide[] = [
  {
    key: DA.ActivatedNoFirstDashScreens.Start,
    title: t.start.title(),
    subtitle: t.pageHeading(),
    content: StartADashContent,
  },
  {
    key: DA.ActivatedNoFirstDashScreens.Heatmap,
    title: t.heatmap.title(),
    subtitle: t.pageHeading(),
    content: AcceptAnOrderContent,
  },
  {
    key: DA.ActivatedNoFirstDashScreens.Order,
    title: t.order.title(),
    subtitle: t.pageHeading(),
    content: CompleteAnOrderContent,
  },
  {
    key: DA.ActivatedNoFirstDashScreens.Support,
    title: t.support.title(),
    subtitle: t.pageHeading(),
    content: GetSupportContent,
  },
]

export default activatedNoFirstDashSlideDeck
